<page-load-header *ngIf="!initialized"></page-load-header>

<div class="row mb-3">
  <div class="col-md-6">
    <div class="dropdown"><h3>Sales History</h3></div>
    <div *ngIf="history && history.length > 0" class="dropdown">
      <h4>Total Earnings: {{ totalRevenue | currency }}</h4>
    </div>
  </div>
  <div class="col-md-6 text-right">
    <button class="btn btn-primary" type="button" tabindex="0" [routerLink]="['../author-course']">Author a Course</button>
  </div>
</div>
<div *ngIf="initialized">
  <div class="row no-gutters no-candidates" style="height: 300px;" *ngIf="history && history.length == 0">
    <div class="col-sm-12 my-auto">
      <h1><i class="fas fa-empty-set"></i></h1>
      <h4>No Sales Yet.</h4>
      <p>Check back soon!</p>
      <a [routerLink]="['../author-course']" class="btn btn-instagram">Author a Course</a>
    </div>
  </div>

  <div class="card">
    <div class="card-body p-4" *ngIf="history && history.length > 0">
      <!-- Activity Table -->
      <div class="table-responsive-md u-datatable">
        <table class="js-datatable table table-borderless u-datatable__striped u-datatable__content u-datatable__trigger mb-5" data-dt-info="#datatableInfo" data-dt-search="#datatableSearch" data-dt-entries="#datatableEntries" data-dt-page-length="12" data-dt-is-responsive="false" data-dt-is-show-paging="true" data-dt-details-invoker=".js-datatabale-details" data-dt-select-all-control="#invoiceToggleAllCheckbox" data-dt-pagination="datatablePagination" data-dt-pagination-classes="pagination mb-0" data-dt-pagination-items-classes="page-item" data-dt-pagination-links-classes="page-link" data-dt-pagination-next-classes="page-item" data-dt-pagination-next-link-classes="page-link" data-dt-pagination-next-link-markup='<span aria-hidden="true">&raquo;</span>' data-dt-pagination-prev-classes="page-item" data-dt-pagination-prev-link-classes="page-link" data-dt-pagination-prev-link-markup='<span aria-hidden="true">&laquo;</span>'>
          <thead>
            <tr class="text-uppercase font-size-1">
              <th scope="col" class="font-weight-medium">
                <div class="d-flex justify-content-between align-items-center">
                  Id
                </div>
              </th>
              <th scope="col" class="font-weight-medium">
                <div class="d-flex justify-content-between align-items-center">
                  Course
                </div>
              </th>
              <th scope="col" class="font-weight-medium">
                <div class="d-flex justify-content-between align-items-center">
                  Amount
                </div>
              </th>

            </tr>
          </thead>
          <tbody class="font-size-1">
            <tr *ngFor="let course of history">
              <td class="align-middle text-secondary font-weight-normal">{{ course.createdDate | date:'longDate'}}</td>
              <td class="align-middle">
                <div class="media align-items-center">
                  <span class="btn btn-sm btn-icon btn-soft-success rounded-circle mr-2">
                    <span class="btn-icon__inner font-weight-medium">C</span>
                  </span>
                  <span
                    >{{ course.courseEventTitle }}</span
                  >
                </div>
              </td>
              <td class="align-middle text-dark">{{ course.amount | currency }}</td>

            </tr>
          </tbody>
        </table>
      </div>
      <!-- End Activity Table -->

      <!-- Pagination -->
      <div class="d-flex align-items-center">
        <nav id="datatablePagination" aria-label="Activity pagination"></nav>

        <small id="datatableInfo" class="text-secondary ml-auto"></small>
      </div>
      <!-- End Pagination -->
    </div>
  </div>
</div>
